<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['loggedIn', 'authtoken']),
    wecLink() {
      let link = process.env.VUE_APP_SANDKASTENLIGA_WEC_BASE_URL
      if (this.loggedIn)
        link += '?legacy_auth=' + this.authtoken.token
      return link
    }
  }
}
</script>
